<template>
  <div class="controls-overlay">
    <div class="control-container" :style="controlStyle" style="position:absolute;transform:translate(-50%, -50%);transition:none">
      <button placement="bottom" v-if="controlTypeToShow === 'placeholder'" @click="showUploadDialog" v-b-tooltip.hover title="Replace Image" variant="clear">
        <i class="fa fa-upload" aria-hidden="true"></i>
      </button>
      <TextBlock v-else-if="controlTypeToShow==='block'" :bus="bus"></TextBlock>
    </div>

    <BleedPointDisplay v-if="displayBleed" :bleedPoints="bleedPoints"></BleedPointDisplay>

    <input ref="hiddenFileInput" :accept="validUploadTypes" type="file" style="display:none;" @change="uploadFile"></input>
  </div>
</template>


<script>
  import {mapGetters} from 'vuex';
  import BleedPointDisplay from './BleedPointDisplay';
  import TextBlock from './inlineControls/TextBlock';
  import filestackClient from "../../../lib/filestackClient";
  import retrieveBase64FromFilestack from "../../../lib/retrieveBase64FromFilestack";

  export default{
    components: {
      BleedPointDisplay,
      TextBlock
    },
    props: {
      fabricCanvas: {
        type: Object,
        default:null
      },
      bleedPoints:{
        type: Array,
        default:[]
      },
      displayBleed: {
        type: Boolean,
        default: true
      },
      bus: {
        type: Object,
        default: null
      }
    },
    data(){
      return {
        controlTypeToShow: null,
        controlsX: 0,
        controlsY: 0,
        canvasBound : false
      }
    },
    computed:{
      ...mapGetters(['validUploadTypes', 'flags', 'isTemplate']),
      controlStyle(){
        const style =  {
          position : 'absolute',
          pointerEvents: 'all',

          display: this.controlTypeToShow ? 'block' : 'none',
          top: this.controlsY + 'px',
          left: this.controlsX + 'px'
        }
        return style;
      }
    },
    methods:{

      bindCanvasEvents(){
        console.log('bindCanvasEvents');
        this.fabricCanvas.on({
          'object:modified': (event) => {
            this.updateControls(event.target);
          },
          'selection:created':(event) => {
            this.updateControls(event.target);
          },
          'selection:updated':(event) => {
            this.updateControls(event.target);
          },
          'object:moving':(event) =>{
            this.controlTypeToShow = null;
          },
          'selection:cleared':(event) =>{
            this.controlTypeToShow = null;
          }
        });
      },

      updateControls(obj){
        const {isPlaceholder} = (obj || {}).brandly || {};
        const isSelection = obj ? obj.type === 'activeSelection' : false;

        const setControlType = (obj, type) => {
          if (obj){
            this.controlTypeToShow = type;
            const objRect = obj.getBoundingRect();
            this.controlsX = objRect.left + objRect.width / 2;
            this.controlsY = objRect.top + objRect.height / 2;
          }
          else{
            this.controlTypeToShow = null;
          }
        }

        // const isSelection = (obj && obj.type === 'activeSelection');
        if (isPlaceholder){
          setControlType(obj, 'placeholder');
        }
        else if (this.flags.enableBlocks && isSelection && this.isTemplate){
          setControlType(obj, 'block');
        }
        else{
          this.controlTypeToShow = null;
        }
        this.obj = obj;

      },
      async showUploadDialog(){
        if (this.flags.filestackUpload){
          const obj = this.fabricCanvas.getActiveObject();
          let ratio = 1;
          const rect = obj.getBoundingRect();
          if (rect.width && rect.height){ //prevent div/0
            ratio = rect.width / rect.height;
          }
          const client = await filestackClient();

          client.picker({
            transformations: {
              crop: {
                aspectRatio: ratio,
                force: true
              }
            },
            onOpen:() => {
              this.bus.$emit('filestackDialogOpen');
            },
            onClose:() => {
              this.bus.$emit('filestackDialogClosed');
            },
            onFileUploadFinished : async response => {
              const base64 = await retrieveBase64FromFilestack(response.handle);
              this.$emit('fileData', base64);
            }}).open();
        }
        else{
          this.$refs.hiddenFileInput.click();
        }
      },
      uploadFile(event){
        const file = event.target.files[0];
        if (file){
          const reader = new FileReader();
          reader.onload = (fileEvent) => {
            const data = fileEvent.target.result;
            this.$emit('fileData', data);
          };
          reader.readAsDataURL(file);
        }
      }
    },
    watch:{
      fabricCanvas(val){
        if (this.canvasBound || !val){
          return;
        }
        this.bindCanvasEvents(val);
        let obj = this.fabricCanvas.getActiveObject();
        if (obj) this.updateControls(obj);
        this.canvasBound = true;
      }
    }
  }
</script>

<style scoped>

  .controls-overlay{
    position:absolute;
    top:0px;
    left:0px;
    width:100%;
    height:100%;
    pointer-events:none;
    transition:none;
  }

</style>



// WEBPACK FOOTER //
// src/components/pages/editor/EditorControlsOverlay.vue